import { useMemo } from "react";
import { getPageLayout } from "./constants.js";
function usePageSplitter(steps, measuredHeights, pageHeightPx) {
  const { availableHeights } = getPageLayout(pageHeightPx);
  return useMemo(() => {
    const pages = [];
    const stepOffsets = [];
    let cumulative = 0;
    for (const step of steps) {
      stepOffsets.push(cumulative);
      cumulative += step.length;
    }
    steps.forEach((stepQuizzes, stepIdx) => {
      if (stepQuizzes.length === 0) {
        pages.push({
          stepIdx,
          isFirstOfStep: true,
          quizzes: [],
          quizStartNum: 1
        });
        return;
      }
      const isStep1 = stepIdx === 0;
      const globalOffset = stepOffsets[stepIdx];
      let isFirst = true;
      let pos = 0;
      while (pos < stepQuizzes.length) {
        const maxH = isFirst ? isStep1 ? availableHeights.step1First : availableHeights.stepFirst : isStep1 ? availableHeights.step1Cont : availableHeights.stepCont;
        let usedH = 0;
        let count = 0;
        while (pos + count < stepQuizzes.length) {
          const quizIdx = globalOffset + pos + count;
          const h = measuredHeights[quizIdx] || 400;
          if (usedH + h > maxH && count > 0) break;
          usedH += h;
          count++;
        }
        if (count === 0) count = 1;
        pages.push({
          stepIdx,
          isFirstOfStep: isFirst,
          quizzes: stepQuizzes.slice(pos, pos + count),
          quizStartNum: pos + 1
        });
        pos += count;
        isFirst = false;
      }
    });
    return pages;
  }, [steps, measuredHeights, availableHeights.step1First, availableHeights.step1Cont, availableHeights.stepFirst, availableHeights.stepCont]);
}
export {
  usePageSplitter
};
//# sourceMappingURL=usePageSplitter.js.map
